'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249 from "./presto.-Register-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$8() {
  this.bv5 = null;
  this.buX = null;
  this.buY = false;
  this.bv6 = null;
  this.bv7 = false;
  this.bva = null;
  this.bv3 = null;
  this.bv4 = false;
  this.buZ = null;
  this.bv0 = false;
  this.bv1 = null;
  this.bv2 = false;
  this.bv8 = false;
  this.bv9 = false;
  this.bv5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bva = "CompactGroup";
}
export { $c_Lpresto_RegisterPageView$$anon$8 as $c_Lpresto_RegisterPageView$$anon$8 };
$p = $c_Lpresto_RegisterPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$8;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$8() {
}
export { $h_Lpresto_RegisterPageView$$anon$8 as $h_Lpresto_RegisterPageView$$anon$8 };
$h_Lpresto_RegisterPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bv5;
});
$p.L = (function() {
  if ((!this.buY)) {
    this.buX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buY = true;
  }
  return this.buX;
});
$p.O = (function() {
  if ((!this.bv7)) {
    this.bv6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bv7 = true;
  }
  return this.bv6;
});
$p.E = (function() {
  return this.bva;
});
$p.t = (function() {
  if ((!this.bv4)) {
    this.bv3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bv4 = true;
  }
  return this.bv3;
});
$p.M = (function() {
  if ((!this.bv0)) {
    this.buZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bv0 = true;
  }
  return this.buZ;
});
$p.Q = (function() {
  if ((!this.bv2)) {
    this.bv1 = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_RegisterPageView$$anon$9();
    this.bv2 = true;
  }
  return this.bv1;
});
$p.w = (function() {
  if ((!this.bv9)) {
    this.bv8 = false;
    this.bv9 = true;
  }
  return this.bv8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee72) => ((p) => \u03b4scrutinee72.ad9(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_RegisterPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$8, "presto.RegisterPageView$$anon$8", ({
  Q7: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$8 as $d_Lpresto_RegisterPageView$$anon$8 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$8.js.map
